export default "__VITE_ASSET__BqAV$MLi__"